const testimonials = [
  {
    quote: "追了这么多同人，终于有个能按目录整理、随时知道更新进度的站点。首页推荐的《火焰意志》一口气看完，太对味了。",
    name: "木叶路过的路人甲",
    role: "长篇连载爱好者",
  },
  {
    quote: "分类很细，想找清水治愈的时候不用在翻车里大海捞针。一乐拉面那部直接治愈了我一整周的疲惫。",
    name: "卡卡西式的懒散",
    role: "治愈向读者",
  },
  {
    quote: "作为创作者，能看到自己的作品被认真整理、如实标注更新，心里很踏实。站里的导航做得干净又专业。",
    name: "红瞳记事",
    role: "同人创作者",
  },
];

export default function Reputation() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="text-xs font-semibold tracking-widest text-accent-500">WHY US</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            为追更而生的同人导航站
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400">
            忍界同人志由火影同人爱好者自发建设，坚持"尊重原著、内容健康、收录有据"的整理原则。我们不做搬运，只做优质内容的目录与导航，让每一份值得被看见的同人作品都能被更容易地发现。
          </p>
          <ul className="mt-6 space-y-3">
            {[
              ["按目录整理，检索更高效", "主题分类 + 关键词搜索，快速定位目标作品"],
              ["如实标注更新，追更不迷路", "每部作品都标注真实的更新进度与热度数据"],
              ["尊重版权，收录有据", "坚持原创收录原则，守护创作者权益"],
            ].map(([t, d]) => (
              <li key={t} className="flex gap-3">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-500/15 text-primary-300">
                  <i className="ri-check-line text-xs" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{t}</p>
                  <p className="text-xs text-foreground-400">{d}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-lg border border-background-300/60 bg-background-100 p-5"
              >
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-300">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-4 border-t border-background-300/60 pt-3">
                  <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}